angular.module("app").component("studentStaffLoginComponent", {
  templateUrl: "app/components/student-staff-login/student-staff-login.tmpl.html",
  controller: function (authService, $state, localStorageService, $timeout) {
    const self = this;
    // Email first: the school is found from the address, so the page never
    // lists which schools use Huedata. Step "email" -> SSO redirect, or
    // step "password" when the domain has no SSO set up.
    self.step = "email";
    self.email = "";
    self.password = "";
    self.isRemembered = false;
    self.error = "";
    self.busy = false;
    self.showPw = false;
    const products = { courses: {}, reports: {}, teaching_materials: {} };
    localStorageService.set("products", products);

    const validEmail = (e) => /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test((e || "").trim());

    self.continue = () => {
      self.error = "";
      const email = (self.email || "").trim();
      if (!validEmail(email)) {
        self.error = "Enter your full school or work email, for example you@school.edu.";
        return;
      }
      self.busy = true;
      // Read back on /single-sign-on/t/:token after the identity provider returns
      localStorageService.set("ssoRemember", !!self.isRemembered);
      authService
        .schoolSSOLogin({ email: email })
        .then((res) => {
          if (res && res.url) {
            window.location.href = res.url;
            return;
          }
          // No SSO for this domain: fall back to a school email + password account
          self.busy = false;
          self.step = "password";
          $timeout(() => {
            const pw = document.getElementById("password");
            if (pw) pw.focus();
          });
        })
        .catch(() => {
          self.busy = false;
          self.error = "We couldn't reach the sign-in service. Please try again in a moment.";
        });
    };

    self.changeEmail = () => {
      self.step = "email";
      self.password = "";
      self.error = "";
      $timeout(() => {
        const el = document.getElementById("email");
        if (el) el.focus();
      });
    };

    self.login = () => {
      self.error = "";
      self.busy = true;
      authService
        .schoolEnterpriseLogin(self.email.trim(), self.password, self.isRemembered)
        .then(function (data) {
          self.busy = false;
          if (data && data.success === true) {
            $state.go("landing-page");
          } else {
            self.error = "pw";
          }
        })
        .catch(() => {
          self.busy = false;
          self.error = "pw";
        });
    };
  },
});
